export default __webpack_public_path__ + "static/media/ava-sdr.88595e1b.png";